import moment from 'moment-timezone'

export const getTzDate = (date, lang) => {
  switch (lang) {
    case 'us':
      return moment.tz(date, 'America/Los_Angeles')
    case 'zh-tw':
      return moment.tz(date, 'Asia/Taipei')
    default:
      return moment(date)
  }
}

export const serverTime = (lang) => (date) => {
  return getTzDate(date, lang)
}

export const getServerDateTime = serverTime(process.env.VUE_APP_LANG)

export const getLocalDateTime = (date) => moment(date)

export const convertLocalDateTime = (date) =>
  getServerDateTime(date).tz(moment.tz.guess())

export const getUtcText = (timezone) => {
  const offset = moment.tz.zone(timezone).utcOffset(new Date())
  return offset < 0 ? `UTC+${offset / -60}` : `UTC-${offset / 60}`
}

export const getTimezone = () => getUtc(process.env.VUE_APP_LANG)

export const getUtc = (lang) => {
  switch (lang) {
    case 'us':
      return getUtcText('America/Los_Angeles')
    case 'zh-tw':
      return getUtcText('Asia/Taipei')
    default:
      return getUtcText('Asia/Tokyo')
  }
}
